import { IconType } from 'react-icons/lib';
import {
  LuCircleAlert,
  LuCircleCheck,
  LuCircleX,
  LuTriangleAlert,
} from 'react-icons/lu';

import { Status } from '../../../../../constants/Utils';

export const BADGE_STATUS_TO_ICON_MAP: Record<Status, IconType> = {
  [Status.Fail]: LuCircleX,
  [Status.Info]: LuCircleAlert,
  [Status.Neutral]: LuCircleX,
  [Status.Pending]: LuCircleAlert,
  [Status.Success]: LuCircleCheck,
  [Status.Warning]: LuTriangleAlert,
};
